import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetMunicipalities_municipalityIdSolar_connections_idLatest = z.any()
export type TagsGetMunicipalities_municipalityIdSolar_connections_idLatest = z.infer<typeof tagsGetMunicipalities_municipalityIdSolar_connections_idLatest>

export const paramsGetMunicipalities_municipalityIdSolar_connections_idLatest = z.object({ "municipalityId": z.string().uuid(), "id": z.string().uuid() })
export type ParamsGetMunicipalities_municipalityIdSolar_connections_idLatest = z.infer<typeof paramsGetMunicipalities_municipalityIdSolar_connections_idLatest>

export const responseGetMunicipalities_municipalityIdSolar_connections_idLatest = z.object({ "payload": z.union([z.null(), z.object({ "sourceAt": z.string().datetime({ offset: true }), "receivedAt": z.string().datetime({ offset: true }), "schemaVersion": z.number(), "metrics": z.record(z.union([z.number(), z.null()])).superRefine((value, ctx) => {
for (const key in value) {
if (key.match(new RegExp("^(.*)$"))) {
const result = z.union([z.number(), z.null()]).safeParse(value[key])
if (!result.success) {
ctx.addIssue({
          path: [...ctx.path, key],
          code: 'custom',
          message: `Invalid input: Key matching regex /${key}/ must match schema`,
          params: {
            issues: result.error.issues
          }
        })
}
}
}
}), "metadata": z.object({ "deviceId": z.string(), "inverterSerial": z.string(), "inverterType": z.union([z.string(), z.null()]), "inverterStatus": z.union([z.string(), z.null()]), "batteryStatus": z.union([z.string(), z.null()]) }) })]).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetMunicipalities_municipalityIdSolar_connections_idLatest = z.infer<typeof responseGetMunicipalities_municipalityIdSolar_connections_idLatest>

interface IGetMunicipalities_municipalityIdSolar_connections_idLatest extends BaseMethodType {
  tags: TagsGetMunicipalities_municipalityIdSolar_connections_idLatest,
  params: ParamsGetMunicipalities_municipalityIdSolar_connections_idLatest,
  response: ResponseGetMunicipalities_municipalityIdSolar_connections_idLatest
}
export const URL = '/municipalities/:municipalityId/solar-connections/:id/latest'
export const validation = {
  get: {
    tags: tagsGetMunicipalities_municipalityIdSolar_connections_idLatest,
    params: paramsGetMunicipalities_municipalityIdSolar_connections_idLatest,
    response: responseGetMunicipalities_municipalityIdSolar_connections_idLatest
  }
}
export interface Municipalities_municipalityIdSolar_connections_idLatest extends BaseRouteType {
  get: IGetMunicipalities_municipalityIdSolar_connections_idLatest
}